import { Row } from '@ahmdigital/ui';
import styled from 'styled-components';

export const FullHeightRow = styled(Row)`
  min-height: 100vh;
  min-height: 100dvh; // fallback (above) if browser does not support dvh units
`;
